"use client";

import type { ReactNode } from "react";
import { SubTabs } from "@/components/layout/SubTabs";
import { WEALTH_SECTION, WEALTH_TABS } from "@/lib/nav/sectionTabs";
import dynamic from "@/lib/spa/dynamic";

const WealthShell = dynamic(() => import("@/components/wealth/WealthProvider").then((m) => m.WealthShell), { ssr: false });

export default function WealthLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      <SubTabs tabs={[...WEALTH_TABS]} sticky orderKey={WEALTH_SECTION} />
      <WealthShell>{children}</WealthShell>
    </main>
  );
}
